import axios from "axios";
import { constants } from '../config'

export default class AircraftsService {
    static async get(page, limit, actives, search, listAll) {
        return axios.get(constants.api + '/aircrafts',{
            params:{
                page:page || null,
                limit:limit || null,
                actives:actives,
                search:search || null,
                listAll:listAll || null
            }
        })
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }
    static async uploadImage(file,id) {

        let formData = new FormData();
        formData.append("file", file);

        return axios.post(constants.api + '/aircraft-image/'+id,formData,{
            headers:{
            "Content-type":"multipart/form-data"
            }
        })
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }

    static async deleteImage(id) {
        return axios.delete(constants.api + '/aircraft-image/'+id)
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }

    static async search(search,page,pageSize) {
        return axios.post(constants.api + '/aircraft-search/'+page,{search},{
            params:{
                limit:pageSize
            }
        })
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        response: response.data,
                        ok: false

                    };
                }
            }).catch(error => {
                //console.error(error)
                return {
                    error,
                    ok: false
                }
            })
    }

    static async getByType(id) {
        return axios.get(constants.api + '/aircrafts-bytype/'+id)
            //aircrafts-bytype/id-do-tipo
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        response: response.data,
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    error,
                    ok: false
                }
            })
    }

    static async getActive() {
        return axios.get(constants.api + '/aircrafts-actives')
            //aircrafts-bytype/id-do-tipo
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        response: response.data,
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    error,
                    ok: false
                }
            })
    }

    static async getById(id) {
        return axios.get(constants.api + '/aircraft/'+ id)
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        response: response.data,
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    error,
                    ok: false
                }
            })
    }

    static async update(id, data) {
        return axios.put(constants.api + '/aircraft/' + id, data)
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        response: response.data,
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    error,
                    ok: false
                }
            })
    }
    static async create(data) {
        return axios.post(constants.api + '/aircraft', data)
            .then(response => {
                if (response.status) {
                    return {
                        response: response,
                        ok: true,
                    }
                }
                else {
                    return {
                        response: response.data,
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    error,
                    ok: false
                }
            })
    }
    



}


// WEBPACK FOOTER //
// ./src/tools/AircraftsService.js